import { motion } from "framer-motion";
import { Check } from "lucide-react";

const values = [
  {
    title: "Moderne Websites",
    desc: "Wir bauen mit aktuellem Frontend-Stack — schnell, barrierearm, ohne Plugin-Wildwuchs.",
  },
  {
    title: "Für lokale Unternehmen",
    desc: "Wir verstehen die Anforderungen kleiner und mittlerer Betriebe in Thüringen.",
  },
  {
    title: "Strukturierter Prozess",
    desc: "Klares Vorgehen statt Bauchgefühl. Sie wissen jederzeit, was als Nächstes passiert.",
  },
  {
    title: "Klare Kommunikation",
    desc: "Ein fester Ansprechpartner, kurze Wege, ehrliche Einschätzung — ohne Agentursprech.",
  },
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 sm:py-32 border-t border-white/[0.05] overflow-hidden"
    >
      <div className="absolute -right-40 top-1/2 -translate-y-1/2 w-[520px] h-[520px] glow-blue opacity-30 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <span className="text-[11px] uppercase tracking-[0.22em] text-zinc-500 font-semibold">
            ↳ Über uns
          </span>
          <motion.h2
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
            className="mt-3 font-display text-3xl sm:text-5xl text-white tracking-tight leading-[1.05]"
          >
            Ein kleines Studio mit hohen Ansprüchen.
          </motion.h2>
          <p className="mt-6 text-zinc-400 leading-relaxed text-base">
            Grayscale Media ist ein Designstudio aus Thüringen. Wir glauben,
            dass auch lokale Unternehmen eine Website verdienen, die zeitgemäß
            aussieht und technisch sauber gebaut ist — nicht weniger als das.
          </p>
          <p className="mt-4 text-zinc-500 leading-relaxed text-sm">
            Keine endlosen Meetings, keine Fachfremdsprache. Stattdessen:
            ein klarer Prozess, ein fester Ansprechpartner und ein Ergebnis,
            auf das wir beide stolz sind.
          </p>
        </div>

        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
          {values.map((v, i) => (
            <motion.div
              key={v.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              data-testid={`about-value-${i}`}
              className="rounded-2xl border border-white/[0.08] bg-white/[0.02] p-6 hover:border-white/[0.18] transition-colors duration-500"
            >
              <div className="flex items-center gap-3">
                <span className="w-6 h-6 rounded-full bg-blue-500/10 border border-blue-500/30 flex items-center justify-center">
                  <Check className="w-3 h-3 text-blue-300" />
                </span>
                <h3 className="font-display text-base text-white tracking-tight">
                  {v.title}
                </h3>
              </div>
              <p className="mt-3 text-sm text-zinc-400 leading-relaxed">
                {v.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
